// Valores constantes

export const DEBUG = false;

const protocols = {
  /* Options Answer */
  ANSWER_A : 'answerA',
  ANSWER_B : 'answerB',
  ANSWER_C : 'answerC',
  ANSWER_D : 'answerD',
  ANSWER_E : 'answerE',
  ANSWER_F : 'answerF',
  ANSWER_G : 'answerG',
  ANSWER_H : 'answerH',
  ANSWER_I : 'answerI',
  ANSWER_J : 'answerJ',
  ANSWER_K : 'answerK',
  ANSWER_L : 'answerL',
  ANSWER_M : 'answerM',
  ANSWER_N : 'answerN',
  ANSWER_O : 'answerO',
  ANSWER_P : 'answerP',
  ANSWER_Q : 'answerQ',
  ANSWER_R : 'answerR',

  /* tiempos para evitar que el token caduque antes de lo deseado */
  //TOKEN_EXPIRATION_TIME: 3600000, //60 minutos
  //TOKEN_WARNING_TIME: 3300000, //55 minutos
  //NOTE: Para realizar pruebas
  TOKEN_EXPIRATION_TIME: 60000, //1 minuto
  TOKEN_WARNING_TIME: 50000, //50 segundos

  /* Rutas de la aplicación */
  ROUTE_WELCOME: '/mercado_virtual/inicio',
  ROUTE_MARKET: '/mercado_virtual/prueba',
  ROUTE_MARKET_INCLUSION: '/cuestionario_inclusion',
  ROUTE_MARKET_SOCIO: '/cuestionario_sociodemografico',
  ROUTE_MARKET_SIMULACION: '/simulacion',
  ROUTE_MARKET_SALIDA: '/cuestionario_salida',
  ROUTE_MARKET_SUMMARY: '/resumen',
  
  ROUTE_USER_LOGIN: '/mercado_virtual/login',
  ROUTE_LOGIN_ADMIN: '/mercado_virtual/admin/login',
  ROUTE_HOME_ADMIN: '/mercado_virtual/admin/panel/home',
  ROUTE_LABELS_ADMIN: '/mercado_virtual/admin/panel/labels',
  ROUTE_QUESTIONNAIRE_ADMIN: '/mercado_virtual/admin/panel/questionnaire',
  ROUTE_LANGUAGE_ADMIN: '/mercado_virtual/admin/panel/language',

    //RUTAS BACK
  SocioDemografico: '/mercado_virtual/prueba/cuestionario_sociodemografico',
  Asentimiento: '/mercado_virtual/prueba/cuestionario_sociodemografico',
  MenosSaludable: '/mercado_virtual/prueba/simulacion',
  Simulacion: '/mercado_virtual/prueba/simulacion',
  ResumenCompra: '/mercado_virtual/prueba/simulacion',
  CuestionarioCampana: '/mercado_virtual/prueba/cuestionario_salida',
  CuestionarioSalida: '/mercado_virtual/prueba/cuestionario_salida',
  Resumen: '/mercado_virtual/prueba/resumen',

  /* Departamentos de procuctos */
  ALL_DEPARTMENTS: 'home',
  BEVERAGES : 'BEVERAGES',
  SNACKS : 'SNACKS',
  CEREALS : 'CEREALS',
  DAIRY_PRODUCTS : 'DAIRY_PRODUCTS',
  READY_TO_EAT : 'READY_TO_EAT',
  SHOPPING_CART : 'shoppingCart',
  PRODUCTS_CHECKOUT: 'checkout',
  SUMMARY_LABEL: 'summary',
  EXERCISE: 'exercise',

  STARTING_MONEY : 5000,

  STORAGE_SETTINGS : 'settings_insp',
  STORAGE_SETTINGS_ADMIN : 'settings_insp_admin',
  STORAGE_INCLUSION_QUESTIONNAIRE : 'ic_insp',
  STORAGE_SOCIO_QUESTIONNAIRE : 'sc_insp',
  STORAGE_EXIT_QUESTIONNAIRE : 'ec_insp',
  STORAGE_PRODUCTS : 'products_insp',
  STORAGE_MARKET: 'vm_market',
  STORAGE_METRICS: 'vm_metrics',
  STORAGE_SUMMARIES: 'vm_summaries',


  /* INCLUSION QUESTIONNAIRE QUESTIONS */
  IC_QUESTION_COUNTRY   : 'IC_QUESTION_COUNTRY',
  IC_QUESTION_ONE   : 'IC_QUESTION_ONE',
  IC_QUESTION_TWO   : 'IC_QUESTION_TWO',
  IC_QUESTION_THREE : 'IC_QUESTION_THREE',
  IC_QUESTION_FOUR  : 'IC_QUESTION_FOUR',
  IC_CONTRACT       : 'IC_CONTRACT',

  /* SOCIO-DEMOGRAPHIC QUESTIONNAIRE OPTIONS */
  SDC_SECTION_ONE : 'SDC_SECTION_ONE',
  SDC_SECTION_TWO : 'SDC_SECTION_TWO',
  SDC_SECTION_THREE : 'SDC_SECTION_THREE',
  SDC_SECTION_FOUR : 'SDC_SECTION_FOUR',
  SDC_SECTION_FIVE : 'SDC_SECTION_FIVE',
  SDC_SECTION_SIX : 'SDC_SECTION_SIX',
  SDC_SECTION_SEVEN : 'SDC_SECTION_SEVEN',
  SDC_SECTION_EIGHT : 'SDC_SECTION_EIGHT',
  SDC_SECTION_NINE : 'SDC_SECTION_NINE',

  /* END QUESTIONNAIRE QUESTIONS */
  INSTRUCCTIONS : 'INSTRUCCTIONS',
  EC_SECTION_CAMPAIGN : 'EC_SECTION_CAMPAIGN',
  EC_SECTION_ONE : 'EC_SECTION_ONE',
  EC_SECTION_TWO_E1 : 'EC_SECTION_TWO_E1',
  EC_SECTION_TWO_E2 : 'EC_SECTION_TWO_E2',
  EC_SECTION_TWO_E3 : 'EC_SECTION_TWO_E3',
  EC_SECTION_THREE_BEVERAGES : 'EC_SECTION_THREE_BEVERAGES',
  EC_SECTION_THREE_SNACKS : 'EC_SECTION_THREE_SNACKS',
  EC_SECTION_THREE_CEREALS : 'EC_SECTION_THREE_CEREALS',
  EC_SECTION_THREE_DAIRY : 'EC_SECTION_THREE_DAIRY',
  EC_SECTION_THREE_READY: 'EC_SECTION_THREE_READY',

  /* SUMMARIES */
  S_POLL : 'S_POLL',
  S_QUIZ : 'S_QUIZ',
  S_PURCHASE : 'S_PURCHASE',
  S_END_SCREEN : 'S_END_SCREEN',


  REMAINING_TIME_1: 60000,
  REMAINING_TIME_2: 30000,

  TICKETS_EXPIRE: 'BOLETOS AGOTADOS',
  ACCESO_DENEGADO: 'ACCESO DENEGADO',
  CORREO_NO_CONFIRMADO: 'CORREO NO CONFIRMADO',
  PROCESO_FINALIZADO: 'PROCESO FINALIZADO',
  MARKET_ONE: 1,
  MARKET_TWO: 2,
  MARKET_THREE: 3,
  MARKET_FOUR: 4,
  MARKET_FIVE: 5,
  MARKET_SIX: 6,

  SPANISH: 'Esp',
  ENGLISH: 'Eng',
  ADMINISTRATOR: 'Administrador',
  USER: 'Usuario',

    PAIS: [
        "",
        "mx",
        "ar",
        "pa",
        "ec",
        "co",
        "cr"
    ],

    ESTADO: [
        {
            label: "Aguascalientes",
            value: "1"
        },
        {
            label: "Baja California",
            value: "2"
        },
        {
            label: "Baja California Sur",
            value: "3"
        },
        {
            label: "Campeche",
            value: "4"
        },
        {
            label: "Coahuila de Zaragoza",
            value: "5"
        },
        {
            label: "Colima",
            value: "6"
        },
        {
            label: "Chiapas",
            value: "7"
        },
        {
            label: "Chihuahua",
            value: "8"
        },
        {
            label: "Ciudad de México",
            value: "9"
        },
        {
            label: "Durango",
            value: "10"
        },
        {
            label: "Estado de México",
            value: "15"
        },
        {
            label: "Guanajuato",
            value: "11"
        },
        {
            label: "Guerrero",
            value: "12"
        },
        {
            label: "Hidalgo",
            value: "13"
        },
        {
            label: "Jalisco",
            value: "14"
        },
        {
            label: "Michoacán",
            value: "16"
        },
        {
            label: "Morelos",
            value: "17"
        },
        {
            label: "Nayarit",
            value: "18"
        },
        {
            label: "Nuevo León",
            value: "19"
        },
        {
            label: "Oaxaca",
            value: "20"
        },
        {
            label: "Puebla",
            value: "21"
        },
        {
            label: "Querétaro",
            value: "22"
        },
        {
            label: "Quintana Roo",
            value: "23"
        },
        {
            label: "San Luis Potosí",
            value: "24"
        },
        {
            label: "Sinaloa",
            value: "25"
        },
        {
            label: "Sonora",
            value: "26"
        },
        {
            label: "Tabasco",
            value: "27"
        },
        {
            label: "Tamaulipas",
            value: "28"
        },
        {
            label: "Tlaxcala",
            value: "29"
        },
        {
            label: "Veracruz",
            value: "30"
        },
        {
            label: "Yucatán",
            value: "31"
        },
        {
            label: "Zacatecas",
            value: "32"
        },
    ]

}

export default protocols;



// WEBPACK FOOTER //
// ./src/common-protocols.js